import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/Button';
import { NetworkBackground } from '../effects/NetworkBackground';
import styles from './HeroSection.module.css';

export const HeroSection = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="hero" className={styles.hero}>
      {/* Animated network background */}
      <NetworkBackground />

      {/* Decorative elements */}
      <div className={styles.decorCircle1} />
      <div className={styles.decorCircle2} />
      <div className={styles.decorDot1} />
      <div className={styles.decorDot2} />
      <div className={styles.decorRing} />

      {/* Content */}
      <div className={`${styles.content} ${visible ? styles.contentVisible : styles.contentHidden}`}>
        {/* Badge */}
        <div className={styles.badge}>
          <span className={styles.badgeDot} />
          {t('hero.badge')}
        </div>

        {/* Headline */}
        <h1 className={styles.headline}>
          {t('hero.headline1')}{' '}
          <span className={styles.headlineGradient}>{t('hero.headline2')}</span>
        </h1>

        {/* Subtitle */}
        <p className={styles.subtitle}>{t('hero.subtitle')}</p>

        {/* CTAs */}
        <div className={styles.ctas}>
          <Button variant="primary" href="/#services" showArrow>
            {t('hero.cta_primary')}
          </Button>
          <Button variant="secondary" href="/#contact">
            {t('hero.cta_secondary')}
          </Button>
        </div>
      </div>

      {/* Bottom gradient fade to light body */}
      <div className={styles.bottomFade} />
    </section>
  );
};
